function expand_tag_cloud() {
  $.getJSON("/tagcloud.json", function (data) {
    const pairs: Array<[string, number]> = [];
    for (const tag in data) {
      pairs.push([tag, data[tag]])
    }
    pairs.sort();
    $('#tagcloud').each(function() {
      let tag_cloud_html = "";
      for (const [tag, count] of pairs) {
        const scale = Math.floor(Math.log2(count))
        tag_cloud_html += `
<span class="hashtag tag_cloud_entry tag_scale${scale}">
<a href="/gollum/search?q=%23${tag.slice(1)}">${tag}</a></span>
`;
      }
      console.log(tag_cloud_html);
      $(this).html(tag_cloud_html);
    })
  });
}

export function link_hashtags() {
  const pat =
    '<span class="hashtag">' +
    '<a href="/gollum/search?q=%23$1">#$1</a></span>';
  const texts = $(".markdown-body")
    .find("*")
    .not("iframe")  // needed to prevent CORS when iframe is from different domain
    .contents()
    .filter(function () {
      return (
        this.nodeType == 3 &&
        this.textContent.trim().length > 1 &&
        this.parentElement.tagName != "A"
      );
    });
  texts.each(function () {
    const updated = this.textContent.replace(/#([^\s<>]+)(?=[<>\s]|$)/g, pat);
    if (updated != this.textContent) {
      const text_node = <Text>this;
      text_node.replaceWith($("<span>" + updated + "</span>")[0]);
    }
  });

  expand_tag_cloud();
}
